<template>
    <div class="profile-card">
        <div class="profile-info">
            <p />
            <p />

            <p />
            <p />
            <p />
            <p />

        </div>
    </div>
</template>

<script>

export default {
    name: "load"
    
}
</script>


<style scoped>
.profile-card .profile-image__img {
  width: 10%;
  padding-top: 10%;
  border-radius: 50%;
  background-color: #ddd;
}

.profile-info span {
  min-width: 100px;
  height: 16px;
  display: inline-block;
  background-color: #ddd;
}

.profile-info h3 {
  content: ' ';
  width: 250px;
  height: 24px;
  background-color: #ddd;
  margin: 10px 0;
}

.profile-info p {
  width: 100%;
  background-color: #ddd;
  height: 16px;
  line-height: 140%;
}
</style>
